<template>
  <div
    class="__custom-switch"
    :class="{ horizontal: horizontal, padding: padding, form: form }"
    :style="{ width: width }"
  >
    <div class="label" v-if="label">
      <span>{{ label }}</span>
      <HelpPopover placement="top" v-if="helpMsg">{{ helpMsg }}</HelpPopover>
    </div>

    <div class="switch-area">
      <el-switch v-model="currentSelect" :disabled="disabled"> </el-switch>
    </div>

    <div class="extra-contents" v-if="!!this.$slots['extra-contents']">
      <slot name="extra-contents" v-if="selectable && value"> </slot>
    </div>
  </div>
</template>

<script>
import HelpPopover from './HelpPopover';

export default {
  name: 'CustomSwitch',
  components: { HelpPopover },
  props: {
    value: Boolean,
    disabled: Boolean,

    // layout
    label: String,
    helpMsg: String,
    horizontal: Boolean,
    width: { type: String, default: '100%' },
    padding: Boolean,
    form: Boolean,
    selectable: Boolean,
  },
  computed: {
    currentSelect: {
      get() {
        return !!this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.__custom-switch {
  position: relative;
  display: block;
  box-sizing: border-box;
  width: 100%;
  font-size: 1rem;

  &.horizontal {
    /*display: flex;*/

    .label {
      display: inline-block;
      /*justify-content: flex-end;*/
      /*width: 30%;*/
      padding-right: 1rem;
      margin-bottom: 0;
    }

    .switch-area {
      display: inline-block;

      width: 40px;
      /*justify-content: flex-start;*/
      /*width: 70%;*/
    }

    &.form {
      display: flex;

      .label {
        /*justify-content: flex-end;*/
        width: 30%;
        padding-right: 2rem;
      }

      .switch-area {
        justify-content: flex-start;
        width: 70%;
      }
    }
  }

  &.padding {
    padding: 1rem 0;
  }

  .label {
    /*display: flex;*/
    /*align-items: center;*/
    /*width: 100%;*/
    margin-bottom: 0.3em;
  }

  .switch-area {
    /*width: 100%;*/

    .description {
      position: absolute;
      bottom: 0.3rem;
      font-size: 0.8em;

      .error-msg {
        color: $danger-color;
      }
    }
  }

  .extra-contents {
    padding-top: 0.5rem;
  }
}
</style>
